
export enum MessageBarStateEnum {
    Success,
    Error,
    None,
}
